import { useGTMDispatch as useGTMDispatchDefault } from '@elgorditosalsero/react-gtm-hook';
import app from 'srcJs/App';
import { Dispatch } from 'react';

const useGTMDispatch = (): Dispatch<object> => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let dispatch = () => {};
  if (app.getExternalApp().isEnableGoogleTagManager()) {
    dispatch = useGTMDispatchDefault();
  }
  return dispatch;
};

export { useGTMDispatch };
